<template>
  <div id="card-container" :style="cardContainerStyle">
    <iframe
      data-testid="card-info"
      :src="showDetails ? iFrameUrl : ''"
      id="card"
      class="w-100 h-100"
      v-if="cardStatus === PayJoyCardStatus.ACTIVE"
    ></iframe>
    <img
      :src="useAsset('img/credit-line/enabled_card.png')"
      alt="green card"
      class="w-100"
      v-else-if="cardStatus === PayJoyCardStatus.ELIGIBLE"
      id="green-card-img"
    />
    <img
      :src="useAsset('img/credit-line/cc_locked.png')"
      alt="locked card"
      class="w-100"
      v-else-if="cardStatus === PayJoyCardStatus.BLOCKED"
      id="locked-card-img"
    />
    <img
      v-else
      :src="useAsset('img/credit-line/disabled_card.png')"
      alt="gray card"
      class="w-100"
      id="gray-card-img"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { PayJoyCardStatus } from "@/apps/credit-line/models/PayJoyCardStatus";
import useAsset from "@/apps/credit-line/helpers/useAsset";

interface Props {
  cardStatus: PayJoyCardStatus;
  iFrameUrl?: string;
  showDetails: boolean;
}

defineProps<Props>();

const cardContainerStyle = computed(() => ({
  backgroundImage: `url(${useAsset(
    "img/credit-line/enabled_virtual_card.png"
  )})`,
  backgroundSize: "contain",
}));
</script>

<style scoped>
#card-container {
  background-repeat: no-repeat;
  aspect-ratio: 328/207;
  width: 100%;
}
</style>
